import React from 'react'
import PropTypes from 'prop-types'
import { GradeListWrapper, StyledGradeProgressData } from './component.styles'

const AdminGradeList = ({
  bhuStatus,
  dwbProgressBars,
  grades,
  siteId,
  splitTwoColumns,
}) => {
  const gradeCount = grades?.length ?? 0

  return (
    <GradeListWrapper
      bhuStatus={bhuStatus}
      gradeCount={gradeCount}
      splitTwoColumns={splitTwoColumns}
    >
      {grades?.map(grade => {
        const {
          classesNotStarted,
          lessonsCompleted,
          name,
          numOfClasses,
          totalLessons,
        } = grade
        return (
          <StyledGradeProgressData
            bhuStatus={bhuStatus}
            classesNotStarted={classesNotStarted}
            dwbProgressBars={dwbProgressBars}
            grade={name}
            key={`grade-${name}-progress`}
            lessonsCompleted={lessonsCompleted}
            numOfClasses={numOfClasses}
            siteId={siteId}
            totalLessons={totalLessons}
          />
        )
      })}
    </GradeListWrapper>
  )
}

AdminGradeList.propTypes = {
  bhuStatus: PropTypes.bool,
  dwbProgressBars: PropTypes.bool,
  grades: PropTypes.array,
  siteId: PropTypes.number,
  splitTwoColumns: PropTypes.bool,
}

export default AdminGradeList
